// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const QtyBreakPricing: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width="23"
            height="23"
            viewBox="0 0 23 23"
        >
            <defs>
                <path id="a" d="M0 0h16v16H0z" />
            </defs>
            <g fill="none" fillRule="evenodd">
                <rect width="23" height="23" fill="#00A65A" rx="4" />
                <g transform="translate(3.5 3.5)">
                    <mask id="b" fill="#fff">
                        <use xlinkHref="#a" />
                    </mask>
                    <path
                        fill="#FEFEFE"
                        d="M12.062 11.987a.575.575 0 0 1-.812 0l-.443-.443-.017.015c-.38.285-.848.514-1.26.715l-.189.093a.574.574 0 0 1-.509-1.03l.193-.093c.367-.18.784-.383 1.08-.605.684-.51 1.22-1.241.874-1.74-.296-.427-.647-.363-1.879.34l-.243.14c-.713.4-2.194 1.235-3.147-.142-.508-.732-.381-1.661.286-2.504l-.425-.425a.573.573 0 1 1 .811-.811l.443.443.018-.015c.246-.182.554-.364.967-.572a.574.574 0 1 1 .517 1.024c-.349.176-.611.33-.801.47-.682.506-1.218 1.239-.872 1.738.252.364.535.415 1.64-.208l.236-.134c.967-.552 2.43-1.387 3.382-.008.517.743.388 1.674-.276 2.515l.426.426a.573.573 0 0 1 0 .81M4 5.144a1.143 1.143 0 1 1 0-2.286 1.143 1.143 0 0 1 0 2.286m11.414 1.772L9.086.585C8.764.265 8.127 0 7.672 0H1a1 1 0 0 0-1 1v6.672c0 .457.264 1.093.586 1.414l6.329 6.328c.78.782 2.047.782 2.828 0l5.671-5.671a2 2 0 0 0 0-2.828"
                        mask="url(#b)"
                    />
                </g>
            </g>
        </svg>
    );
};

export default React.memo(QtyBreakPricing);
